import React from 'react'
import PropTypes from 'prop-types'

import { Typography } from 'antd'
import * as Icons from '@ant-design/icons'

import { useInfraction } from './InfractionsContext'

import { colours } from '@qflow/theme'

export const InfractionFlag = ({ names, matchArrayIndex = true }) => {
  const infractions = useInfraction(names, { matchArrayIndex: matchArrayIndex })

  if (infractions.length === 0) {
    return null
  }

  return (
    <Typography.Text type="danger" style={{ color: colours.RED }}>
      <Icons.FlagFilled />
    </Typography.Text>
  )
}

InfractionFlag.propTypes = {
  names: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string
  ]),
  matchArrayIndex: PropTypes.bool
}
